import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enums";
import {
  defaultBusinessPolicyBIState,
  defaultBusinessInterruptionFormValues,
} from "./businessPolicyBusinessInterruption.types";
import {
  fetchBusinessInterruptionAsync,
  saveBusinessInterruptionAsync,
  fetchBusinessInterruptionListAsync,
  fetchLeadBusinessInterruptionListAsync,
} from "./businessPolicyBusinessInterruptionActions";
import { APIError } from "../../../constants/types";

const businessPolicyBusinessInterruptionSlice = createSlice({
  name: "businessPolicyBusinessInterruption",
  initialState: defaultBusinessPolicyBIState,
  reducers: {
    clearBusinessPolicyBIState: () => {
      return defaultBusinessPolicyBIState;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchBusinessInterruptionAsync
      .addCase(fetchBusinessInterruptionAsync.pending, (state) => {
        state.loading = LoadState.InProgress;
      })
      .addCase(fetchBusinessInterruptionAsync.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.data = action.payload || defaultBusinessInterruptionFormValues;
      })
      .addCase(fetchBusinessInterruptionAsync.rejected, (state, action) => {
        state.loading = LoadState.Failed;
        state.error =
          (action.payload as APIError)?.message || "An error occurred";
      })
      // saveBusinessInterruptionAsync
      .addCase(saveBusinessInterruptionAsync.pending, (state) => {
        state.saveLoading = LoadState.InProgress;
      })
      .addCase(saveBusinessInterruptionAsync.fulfilled, (state) => {
        state.saveLoading = LoadState.Loaded;
      })
      .addCase(saveBusinessInterruptionAsync.rejected, (state, action) => {
        state.saveLoading = LoadState.Failed;
        state.error =
          (action.payload as APIError)?.message || "An error occurred";
      })
      // fetchBusinessInterruptionListAsync
      .addCase(fetchBusinessInterruptionListAsync.pending, (state) => {
        state.list.loading = LoadState.InProgress;
        state.list.data = [];
      })
      .addCase(fetchBusinessInterruptionListAsync.fulfilled, (state, action) => {
        state.list.loading = LoadState.Loaded;
        state.list.data = action.payload.data;
        state.list.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchBusinessInterruptionListAsync.rejected, (state) => {
        state.list.loading = LoadState.Failed;
        state.list.data = [];
      })
      // fetchLeadBusinessInterruptionListAsync (lead-binder-additional-tabs) — mirrors
      // fetchBusinessInterruptionListAsync. On failure the list is flipped to Failed so
      // the sub-tab can surface retry.
      .addCase(fetchLeadBusinessInterruptionListAsync.pending, (state) => {
        state.list.loading = LoadState.InProgress;
        state.list.data = [];
      })
      .addCase(
        fetchLeadBusinessInterruptionListAsync.fulfilled,
        (state, action) => {
          state.list.loading = LoadState.Loaded;
          state.list.data = action.payload.data;
          state.list.totalRecords = action.payload.totalRecords;
        }
      )
      .addCase(fetchLeadBusinessInterruptionListAsync.rejected, (state) => {
        state.list.loading = LoadState.Failed;
        state.list.data = [];
      });
  },
});

export const { clearBusinessPolicyBIState } =
  businessPolicyBusinessInterruptionSlice.actions;

export const businessPolicyBusinessInterruptionReducer =
  businessPolicyBusinessInterruptionSlice.reducer;
